import {HttpClient} from '@angular/common/http';
import {HttpService} from '../http.service';
import {Injectable} from '@angular/core';
import {ToastService} from '../toast.service';
import {ReportGroup} from '../../models/report-group.model';
import {ReportDataSourceRequest} from '../../models/data-source/report-data-source-request.model';
import {DataSourceResult} from '../../models/data-source/data-source-result.model';
import {catchError} from 'rxjs';
import {Report} from '../../models/report.model';
import {AuthService} from '@core/services/auth.service';
import {RuntimeEnvironmentService} from '../runtime-environment.service';

@Injectable({providedIn: 'root'})
export class ReportGroupService extends HttpService<ReportGroup> {
  constructor(
    http: HttpClient,
    toastService: ToastService,
    authService: AuthService,
    runtimeEnv: RuntimeEnvironmentService,
  ) {
    super(http, toastService, authService, runtimeEnv, 'reportgroups');
  }

  getList() {
    return this.http.get<ReportGroup[]>(this.buildUrl('list'))
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  getReports(id: number, dataSourceRequest: ReportDataSourceRequest) {
    return this.http.get<DataSourceResult<Report>>(this.buildUrl(`${id}/reports`), {params: this.generateParamsFromDataSourceRequest(dataSourceRequest)})
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }
}
